// extracted by mini-css-extract-plugin
export default {"button-cell-schevron":"button-cell-schevron__nDUZC","icon":"icon__uFsmV"};